import { DOCUMENT, inject, Injectable } from '@angular/core';

export function validateBetaReturnPath(value: string | null): string | null {
    if (!value || !/^\/beta(?:[/?#]|$)/.test(value) || /\s/.test(value))
        return null;
    try {
        const decoded = decodeURIComponent(value);
        if (
            decoded.includes('\\') ||
            Array.from(decoded).some(
                (character) =>
                    character.charCodeAt(0) < 32 ||
                    character.charCodeAt(0) === 127
            ) ||
            /%[0-9a-f]{2}/i.test(decoded)
        )
            return null;
        const path = decoded.split(/[?#]/, 1)[0];
        if (
            path
                .split('/')
                .some((segment) => segment === '.' || segment === '..') ||
            path.includes('//') ||
            /^\/beta\/auth(?:\/|$)/i.test(path)
        )
            return null;
        const parsed = new URL(value, 'https://return.invalid');
        if (parsed.pathname !== value.split(/[?#]/, 1)[0]) return null;
        return value;
    } catch {
        return null;
    }
}

@Injectable({ providedIn: 'root' })
export class BetaReturnService {
    private readonly document = inject(DOCUMENT);

    public get target(): string | null {
        return validateBetaReturnPath(
            new URLSearchParams(this.document.location.search).get('returnTo')
        );
    }

    public get loginTarget(): string {
        const target = this.target;
        return target
            ? `/onboarding?returnTo=${encodeURIComponent(target)}`
            : '/';
    }

    public navigate(value = this.target): boolean {
        const target = validateBetaReturnPath(value);
        if (!target) return false;
        this.document.location.assign(target);
        return true;
    }
}
